import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import BtmFootInplay from "../assets/images/icons/home/home.webp";
import BtmFootSports from "../assets/images/icons/home/cricket.png";
import BtmFootHome from "../assets/images/icons/home/deposit.png";
import BtmFootCasino from "../assets/images/icons/home/bonus.png";
import BtmFootProfile from "../assets/images/icons/home/aviator.png";
import { useSelector } from "react-redux";
import { RouteType, useAppNavigate } from "../hooks/useAppNavigate";

export default function BottomNav() {
  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const { isAuth } = useSelector((state) => state.auth);
  const { appNavigate } = useAppNavigate();

  const footerPages = [
    "sportsbook",
    "sports/ig_pixel",
    "inplaySportsbook",
    "home",
    "live-dealer",
    "profile",
    "sportsbook",
    "casino/evolution",
    "casino/ezugi",
    "public-inplay",
    "public-sports",
    "jetfair",
    // "atlas",
    "gatewaylist",
    "/",
    "sports",
  ];
  useEffect(() => {
    const matchedValue = footerPages.find((f) => {
      if (f === "public-sports") {
        return location?.pathname?.split("/")?.[1] === "public-sports";
      } else {
        return location?.pathname.includes(f);
      }
    });
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  return (
    <>
      <footer className="d-lg-none">
        <div className="footer-menu position-fixed start-0 bottom-0 z-index-2 w-100">
          <ul className="d-flex justify-content-evenly m-0 p-0 list-unstyled BottomNav">
            <li className="inplay">
              <a
                className={activePage === "/" ? "active" : ""}
                href="javascript:void(0)"
                onClick={() => {
                  appNavigate("/sports", RouteType.Protected);
                }}
              >
                <div className="imgBox">
                  <img src={BtmFootInplay} alt="footer nav icon" />
                </div>
                <span>Lobby</span>
              </a>
            </li>
            <li className="sports">
              <a
                className={
                  activePage === "/sports/jetfair?sportName=cricket"
                    ? "active"
                    : ""
                }
                href="javascript:void(0)"
                onClick={() => {
                  appNavigate(
                    "/sports/jetfair?sportName=cricket",
                    RouteType.Protected,
                  );
                }}
              >
                <div className="imgBox">
                  <img src={BtmFootSports} alt="footer nav icon" />
                </div>
                <span>Cricket</span>
              </a>
            </li>
            <li className="home">
              <a
                className={
                  activePage === "gatewaylist" || activePage === "/"
                    ? "active"
                    : ""
                }
                href="javascript:void(0)"
                onClick={() => {
                  appNavigate("/gatewaylist", RouteType.Protected);
                }}
              >
                <div className="imgBox">
                  <img src={BtmFootHome} alt="footer nav icon" />
                </div>
                <span>Deposit</span>
              </a>
            </li>
            <li className="casino">
              <a
                className={activePage === "bonus" ? "active" : ""}
                href="javascript:void(0)"
                onClick={() => {
                  appNavigate("/bonus", RouteType.Protected);
                }}
              >
                <div className="imgBox">
                  <img src={BtmFootCasino} alt="footer nav icon" />
                </div>
                <span>Bonus</span>
              </a>
            </li>
            <li className="profile">
              <a
                className={activePage === "aggapspribe-aviator" ? "active" : ""}
                href="javascript:void(0)"
                onClick={() => {
                  appNavigate(
                    "/casino/aggapspribe-aviator",
                    RouteType.Protected,
                  );
                }}
              >
                <div className="imgBox">
                  <img src={BtmFootProfile} alt="footer nav icon" />
                </div>
                <span>Aviator</span>
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </>
  );
}
